import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  cartItems: [],
};

const cartSlice = createSlice({
  name: "cart",
  initialState: initialState,
  reducers: {
    clearCart(state) {
      state.cartItems = [];
    },
    setCartItems(state, { payload }) {
      // eslint-disable-next-line array-callback-return
      payload.map((item) => {
        state.cartItems.push(item);
      });
    },
    addItem: (state, { payload }) => {
      console.log(payload.id);
      const idx = state.cartItems.findIndex((item) => item.id === payload.id);

      if (idx !== -1) {
        state.cartItems[idx].qty++;
      } else {
        state.cartItems.push(payload);
      }
    },
    deleteItem: (state, action) => {
      const itemId = action.payload;
      state.cartItems = state.cartItems.filter((item) => item.id !== itemId);
    },
    updateQuantItem: (state, action) => {
      const { id, qty } = action.payload;
      if (qty !== 0) {
        state.cartItems = state.cartItems.map((item) => {
          if (item.id === id) {
            return { ...item, qty };
          }
          return item;
        });
      } else {
        state.cartItems = state.cartItems.filter((item) => item.id !== id);
      }
    },
  },
});

export const { clearCart, setCartItems, addItem, deleteItem, updateQuantItem } =
  cartSlice.actions;

export default cartSlice.reducer;
